import { formValueSelector } from 'redux-form';
import { formName } from '../Constants/constants';
import { requestQuote } from '../Actions/actions';
import Debounce from './Debounce';
import { mapProvidersForQuote } from './providerInputParser';
import { dateHelpers } from '@jauntin/utilities';
const { numberOfDays } = dateHelpers;

/**
 *
 * Redux observer that checks for form state changes relevant to price
 * If some value changes, then ask the server for an updated quote
 *
 */

let currentValue;
const formValues = formValueSelector(formName);
const debouncePeriod = 500;

function select(state) {
  const days = numberOfDays(formValues(state, 'eventDates')) || 1;
  return {
    // Keep track of selection, as an update could be triggered even if riskClass doesn't change
    selection: state.formPage.eventType.selection,
    daysOfWeek: formValues(state, 'daysOfWeekField'),

    riskClass: (state.formPage.eventType.selection || { riskClass: 1 })
      .riskClass,
    venueState:
      state.formPage.venue.selectedPlaceAddressComponents.state ||
      formValues(state, 'manualVenueState') ||
      'TX',
    isFederalEntity: state.formPage.venue.isFederalEntity ? 1 : 0,
    isKentuckyEntity: state.formPage.venue.isKentuckyEntity ? 1 : 0,
    venueMunicipalityCode: formValues(state, 'venueMunicipalityCode'),
    averageDailyAttendance:
      parseInt(formValues(state, 'eventDailyGuests'), 10) || 1,
    eventDates: formValues(state, 'eventDates')
      ? formValues(state, 'eventDates').map((d) =>
          dateHelpers.dateOnlyStringFormat(d),
        )
      : [],
    numberOfDays: days,
    gll: formValues(state, 'generalLiabilityCoverage') || 1000000,
    performers: mapProvidersForQuote(
      formValues(state, 'eventPerformersCount'),
      formValues(state, 'performersFrequency'),
      formValues(state, 'performersList'),
      days,
    ),
    goods: mapProvidersForQuote(
      formValues(state, 'eventGoods'),
      formValues(state, 'goodsVendorsFrequency'),
      formValues(state, 'goodsVendorsList'),
      days,
    ),
    food: mapProvidersForQuote(
      formValues(state, 'eventFood'),
      formValues(state, 'foodVendorsFrequency'),
      formValues(state, 'foodVendorsList'),
      days,
    ),
    exhibitors: mapProvidersForQuote(
      formValues(state, 'eventExhibition'),
      formValues(state, 'exhibitorsFrequency'),
      formValues(state, 'exhibitorsList'),
      days,
    ),
    hostLiquor: formValues(state, 'ACHostLiquor') ? 1 : 0,
    personalAndAdvertisingLimit: formValues(
      state,
      'ACPersonalAndAdvertisingLimit',
    )
      ? 1
      : 0,
    productsAndCompletedOperations: formValues(
      state,
      'ACProductsAndCompletedOperations',
    )
      ? 1
      : 0,
    liquorLiability: formValues(state, 'ACSellingLiquor') ? 1 : 0,
    personalProperty: formValues(state, 'ACPersonalProperty') ? 1 : 0,
    cancellation: 0,
    damageToRentedProperty: formValues(state, 'ACDamageToRentedProperty')
      ? 1000000
      : 250000,
    terrorism: formValues(state, 'ACTerrorism') ? 1 : 0,
  };
}

function handleChange({ store }) {
  const previousValue = currentValue;
  currentValue = select(store.getState());
  if (JSON.stringify(previousValue) !== JSON.stringify(currentValue)) {
    // The request will not use selection or daysOfWeek
    const { selection, daysOfWeek, ...send } = currentValue;
    store.dispatch(requestQuote(send));
  }
}

const PriceChangeObserver = (store) => {
  const debounce = new Debounce({ period: debouncePeriod });
  store.subscribe(() => {
    debounce.do(handleChange, { store });
  });
};

export default PriceChangeObserver;
